import React from "react";

import SideBar from "./sidebar/Sidebar";

const Layout = (props) => {
  return <SideBar />;
};

export default Layout;
